module.exports = __webpack_public_path__ + "static/media/Rocker Girl.40548b50.jpg";